import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerLibroRegistriIvaModalComponent } from './worker-libro-registri-iva-modal';

export const WorkerLibroRegistriIvaModalModule: string = ng
    .module('worker-libro-registri_iva-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerLibroRegistriIvaModalComponent', WorkerLibroRegistriIvaModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-libro-registri-iva-modal/worker-libro-registri-iva-modal.module.ts